import React from 'react';
import { Baby, Users, Target, Palette, BookOpen } from '@phosphor-icons/react';

export default function ChildrenLiteratureModule({ metadata, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...metadata, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Age Group */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Target size={16} />
          Target Age Group (आयु वर्ग) <span className="text-red-500">*</span>
        </label>
        <select
          value={metadata.age_group || ''}
          onChange={(e) => handleChange('age_group', e.target.value)}
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        >
          <option value="">Select age group...</option>
          <option value="0-3">Toddlers (0-3 years)</option>
          <option value="4-6">Preschool (4-6 years)</option>
          <option value="7-9">Early Elementary (7-9 years)</option>
          <option value="10-12">Middle Grade (10-12 years)</option>
          <option value="13-17">Young Adult (13-17 years)</option>
        </select>
      </div>

      {/* Story Type */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <BookOpen size={16} />
          Story Type (कहानी का प्रकार)
        </label>
        <select
          value={metadata.story_type || ''}
          onChange={(e) => handleChange('story_type', e.target.value)}
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        >
          <option value="">Select type...</option>
          <option value="fairy_tale">Fairy Tale (परी कथा)</option>
          <option value="fable">Fable (नीतिकथा)</option>
          <option value="adventure">Adventure (रोमांचक कहानी)</option>
          <option value="educational">Educational (शैक्षिक)</option>
          <option value="folktale">Folktale (लोक कथा)</option>
          <option value="poetry">Poetry for Children (बाल कविता)</option>
        </select>
      </div>

      {/* Characters */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Users size={16} />
          Main Characters (मुख्य पात्र)
        </label>
        <textarea
          value={metadata.characters || ''}
          onChange={(e) => handleChange('characters', e.target.value)}
          placeholder="पात्रों की सूची (जैसे: राजा, चूहा, चिड़िया)..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Moral/Lesson */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Palette size={16} />
          Moral / Lesson (शिक्षा / सीख)
        </label>
        <textarea
          value={metadata.moral || ''}
          onChange={(e) => handleChange('moral', e.target.value)}
          placeholder="कहानी से मिलने वाली शिक्षा या संदेश..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Educational Value */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Baby size={16} />
          Educational Value (शैक्षिक मूल्य)
        </label>
        <textarea
          value={metadata.educational_value || ''}
          onChange={(e) => handleChange('educational_value', e.target.value)}
          placeholder="बच्चों के विकास में इस कहानी का योगदान..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Illustration Notes */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Palette size={16} weight="fill" className="text-pink-500" />
          Illustration Notes (चित्रण टिप्पणी)
        </label>
        <textarea
          value={metadata.illustration_notes || ''}
          onChange={(e) => handleChange('illustration_notes', e.target.value)}
          placeholder="चित्रकार के लिए सुझाव या विवरण..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>
    </div>
  );
}
